module.exports = __webpack_public_path__ + "static/media/mode-beauty.f658f430.svg";